const getDateTimeZoneHandled = (date) => {
  if (date instanceof Date) {
    return new Date(date);
  }
  else {

    date = new Date(date);
    var userTimezoneOffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() + userTimezoneOffset);
  }
};

const formatDateMMDDYYYY = (date) => {
  date = getDateTimeZoneHandled(date);

  let month = date.getMonth() + 1;
  if (month < 10) month = '0' + month;
  let day = date.getDate();
  if (day < 10) day = '0' + day;
  let year = date.getFullYear();
  return `${month}/${day}/${year}`;
};

const formatDateMDYYYY = (date) => {
  date = getDateTimeZoneHandled(date);

  let month = date.getMonth() + 1;
  let day = date.getDate();
  let year = date.getFullYear();
  if (isNaN(month) && isNaN(day) && isNaN(year)) {
    return null;
  }
  return `${month}/${day}/${year}`;
};

const formatDateYYYYMMDD = (date, delimiter = '') => {
  date = getDateTimeZoneHandled(date);

  let month = date.getMonth() + 1;
  if (month < 10) month = '0' + month;
  let day = date.getDate();
  if (day < 10) day = '0' + day;
  let year = date.getFullYear();
  return `${year}${delimiter}${month}${delimiter}${day}`;
};

const formatDateDelmtrMMDDYYYY = (date, delimiter = '') => {
  date = getDateTimeZoneHandled(date);

  let month = date.getMonth() + 1;
  if (month < 10) month = '0' + month;
  let day = date.getDate();
  if (day < 10) day = '0' + day;
  let year = date.getFullYear();
  return `${month}${delimiter}${day}${delimiter}${year}`;
};

const formatDateDelmtrYYYYMMDD = (date, delimiter) => {
  return date.replace(/(\d\d\d\d)(\d\d)(\d\d)/, `$1${delimiter}$2${delimiter}$3`);
};

const parseYYYYMMDD = (dateString) => {
  try {
    var parsedDate = dateString.toString().match(/(\d\d\d\d)(\d\d)(\d\d)/);
    return [parsedDate[1], parsedDate[2], parsedDate[3]];
  } catch (e) {

    return [0, 0, 0];
  }
};

//Date of format yyyy-mm-dd
function formatyyyymmdd(date) {
  var d = getDateTimeZoneHandled(date),
    month = '' + (d.getMonth() + 1),
    day = '' + d.getDate(),
    year = d.getFullYear();



  if (month.length < 2)
    month = '0' + month;
  if (day.length < 2)
    day = '0' + day;

  return [year, month, day].join('-');
}

const formatDayMonDD = (dateStr) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let date = getDateTimeZoneHandled(dateStr);

  let day = date.toString().split(' ')[0] + '.';
  let month = months[date.getMonth()];
  let dateString = date.getDate();
  if (dateString < 10) dateString = '0' + dateString.toString();
  date = day + ' ' + month + ' ' + dateString;
  return date;
};

const formatMonDD = (dateStr) => {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  let date = getDateTimeZoneHandled(dateStr);

  let month = months[date.getMonth()];
  let dateString = date.getDate();
  if (dateString < 10) dateString = '0' + dateString.toString();
  date = month + '. ' + dateString;
  return date;
};

const stringtoDate = (dateString) => {
  dateString = dateString.toString();
  let year = dateString.slice(0, 4);
  let month = dateString.slice(4, 6);
  let day = dateString.slice(6, 8);
  let date = year + '/' + month + '/' + day;
  date = getDateTimeZoneHandled(date);

  return date;
};

//Date in DD/MM/YYYYY format
const ddmmyyyyformat = (datesObj) => {
  let date = getDateTimeZoneHandled(datesObj);

  let dd = date.getDate();
  let mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  date = mm + '/' + dd + '/' + yyyy;
  return date;
};

//dd-mm-yyy-dd-mm-yy or dd-mm-yy date to normal date used in Reschedule
const scheduleDate = (targetScheduleDate) => {
  let targetDate = '';

  let count = (targetScheduleDate.match(/-/g) || []).length;
  if (count === 5) {
    targetDate = targetScheduleDate;
    targetDate = targetDate.replace('-', '/');
    targetDate = targetDate.replace('-', '/');
    let date1 = targetDate.split('-')[0];
    let date2 = targetDate.replace(date1 + '-', '');
    date1 = ddmmyyyyformat(date1);
    date2 = ddmmyyyyformat(date2);
    targetScheduleDate = date1 + '-' + date2;
  }
  else if (count === 2) {
    targetDate = ddmmyyyyformat(targetScheduleDate);
    targetScheduleDate = targetDate;
  }

  return targetScheduleDate;
};

//Rechedule final Date
const postPoneDateMonDD = (postDate) => {
  let finalDate = '';
  let count = (postDate.match(/-/g) || []).length;
  if (count === 5) {
    let targetDate = postDate;
    targetDate = targetDate.replace('-', '/');
    targetDate = targetDate.replace('-', '/');
    let date1 = targetDate.split('-')[0];
    let date2 = targetDate.replace(date1 + '-', '');
    date1 = formatMonDD(date1);
    date2 = formatMonDD(date2);
    finalDate = date1 + '-' + date2;
  }
  else if (count === 2) {
    finalDate = formatMonDD(postDate);
  }
  return finalDate;
};

const formatDay = (day) => {
  var j = day % 10,
    k = day % 100;
  if (j === 1 && k !== 11) {
    return day + 'st';
  }
  if (j === 2 && k !== 12) {
    return day + 'nd';
  }
  if (j === 3 && k !== 13) {
    return day + 'rd';
  }
  return day + 'th';
};

const getLongDateString = (d) => {
  if (!(d instanceof Date)) {
    return '';
  }
  var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  return days[d.getDay()] + ' ' + months[d.getMonth()] + ' ' + d.getDate() + ', ' + d.getFullYear();
};

// utils/validators.js
export function luhnCheck(cardNumber) {
  const digits = cardNumber.replace(/\D/g, "");
  let sum = 0;
  let shouldDouble = false;
  for (let i = digits.length - 1; i >= 0; i--) {
    let d = parseInt(digits.charAt(i), 10);
    if (shouldDouble) {
      d *= 2;
      if (d > 9) d -= 9;
    }
    sum += d;
    shouldDouble = !shouldDouble;
  }
  return sum % 10 === 0;
}

export function formatCardNumber(value = "") {
  const digits = value.replace(/\D/g, "").slice(0, 19);
  // group by 4 for readability (works for most cards)
  return digits.replace(/(.{4})/g, "$1 ").trim();
}


const isEmailValid = email => {
  if (/^\w+([+.-]?\w+)*@\w+([.-]?\w+)*(\.\w+)+$/.test(email)) {
    return true;
  }
  return false;
};

export {
  getDateTimeZoneHandled,
  formatDateMMDDYYYY,
  formatDateYYYYMMDD,
  formatDateDelmtrMMDDYYYY,
  parseYYYYMMDD,
  formatDateMDYYYY,
  formatDayMonDD,
  formatMonDD,
  formatyyyymmdd,
  stringtoDate,
  formatDateDelmtrYYYYMMDD,
  scheduleDate,
  ddmmyyyyformat,
  postPoneDateMonDD,
  formatDay,
  getLongDateString,
  isEmailValid
};
